import { createFileRoute } from '@tanstack/react-router';

import Page from '@/screens/chat/skills/id/definition/page';

export const Route = createFileRoute('/_app/_chat/skills/$id/definition/')({
  component: Page,
});
